import { useQuery } from '@tanstack/react-query'

import { getEnterpriseDetails } from '@/api/internal'

export const enterpriseDetailsQueryKey = (enterpriseId: string) => ['enterpriseDetails', enterpriseId]

export const useEnterpriseDetails = (enterpriseId: string) =>
  useQuery({
    queryKey: enterpriseDetailsQueryKey(enterpriseId),
    queryFn: () => getEnterpriseDetails(enterpriseId),
  })
